import React from "react";
// Sticky Footer Pattern: Layout controls full-page height. Do NOT use min-h-screen or similar height utilities in page components. Only Layout should control vertical stretching.
import Header from "./Header";
import Footer from "./Footer";
import { useUserContext } from "../config/UserContext";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { userPreferences } = useUserContext();
  const isTestMode = userPreferences?.isTestMode || localStorage.getItem('identifid-mode') === 'test';

  return (
    <div className="min-h-screen flex flex-col relative">
      <Header />
      {isTestMode && (
        <div className="w-full bg-[#E53E3E] text-white text-center py-1 font-bold text-sm shadow-md z-40 relative">
          ⚠️ TEST DATA MODE - No live records will be affected.
        </div>
      )}
      <main className="flex-1 flex flex-col justify-start">
        {children}
      </main>
      <div className="py-4 w-full flex-shrink-0">
        <Footer />
      </div>
    </div>
  );
}; 